import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  from,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';

export function createApolloClient(
  apolloServerUrl: string,
  authTokenStorageKey: string,
): ApolloClient<NormalizedCacheObject> {
  const httpLink = createHttpLink({
    uri: apolloServerUrl,
  });

  const setAuthHeader = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem(authTokenStorageKey);
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : null,
      },
    });
    return forward(operation);
  });

  const getAuthHeader = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      const context = operation.getContext();
      const {
        response: { headers },
      } = context;

      if (headers) {
        localStorage.setItem(authTokenStorageKey, headers.get('X-Auth-Token'));
      }
      return response;
    });
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    connectToDevTools: process.env.NODE_ENV !== 'production',
    link: from([setAuthHeader, getAuthHeader, httpLink]),
    defaultOptions: {
      mutate: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
      },
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
    },
  });
}
